<script setup lang="ts">
import type { EnqueteInput } from '@/types/schema.generated'
import {
  useCreateEnqueteMutation,
  type EnqueteNewPageContentUserVariableDefinitionFragment,
} from './EnqueteNewPageContent.generated'
import { useAlert } from '@/libs/alertPortal'
import EnqueteForm from '@/features/enquete/components/EnqueteForm/EnqueteForm.vue'
import { useRoute, useRouter } from 'vue-router'

defineProps<{
  userVariableDefinitions: EnqueteNewPageContentUserVariableDefinitionFragment[]
}>()

const alert = useAlert()
const router = useRouter()
const route = useRoute('EnqueteNewPage')

const createMutation = useCreateEnqueteMutation()

const handleSubmit = async (input: EnqueteInput) => {
  const res = await createMutation.mutate({
    input: {
      enquete: input,
    },
  })
  if (!res) {
    throw new Error('failed to create enquete')
  }

  if (res.errors) {
    console.error(res.errors)
    throw new Error('res.errors')
  }

  const data = res.data
  if (!data) {
    throw new Error('data not found')
  }

  alert.success('アンケートを作成しました')

  // eslint-disable-next-line fp/no-mutating-methods
  router.push({
    name: 'EnqueteEditPage',
    params: {
      entranceGUID: route.params.entranceGUID,
      enqueteGUID: data.createEnquete.guid,
    },
  })
}
</script>

<template>
  <div>
    <h1>アンケート 新規作成ページ</h1>
    <EnqueteForm
      :user-variable-definitions="userVariableDefinitions"
      @submit="handleSubmit"
      :class="$style.form"
    />
  </div>
</template>

<style module lang="scss">
.form {
  margin-top: 16px;
}
</style>
